<template>
    <div class="project">
        <el-menu theme="dark" :default-active="activeIndex" class="el-menu-demo" mode="horizontal"
                 @select="handleSelect" router>
            <el-menu-item index="/home/medicine/medicine_list">抓药列表</el-menu-item>
        </el-menu>
        <router-view></router-view>
    </div>
</template>
<script>

  export default {
    name: 'project',
    data() {
      return {
        msg: '项目',
        activeIndex: '/home/medicine/medicine_list',
        handleSelect(key, keyPath) {
        }
      }
    },

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// medicine_menu.vue?14a0fce4